import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Autocomplete, DropdownTheme } from '..';
import { classes } from './Autocomplete.visual.st.css';
import { Toolbox } from '@wix/wix-ui-icons-common';
import { CoreDivider } from '../internal/WixUiCoreComponents/components/CoreDivider';

const options = [
  {
    value: '1',
    id: '1',
    isDisabled: false,
    isSelectable: true,
    displayText: 'Option 1',
    render: () => <div>Option 1</div>,
  },
  {
    value: '2',
    id: '2',
    isDisabled: false,
    isSelectable: true,
    displayText: 'Option 2',
    render: () => <div>Option 2</div>,
  },
  {
    id: 'divider1',
    value: '-',
    render: () => <CoreDivider />,
    isSelectable: false,
    isDisabled: false,
  },
  {
    value: '3',
    id: '3',
    isDisabled: false,
    isSelectable: true,
    displayText: 'Option 3',
    render: () => <div>Option 3</div>,
  },
  {
    value: '4',
    id: '4',
    isDisabled: false,
    isSelectable: true,
    displayText: 'Option 4',
    render: () => <div>Option 4</div>,
  },
];

visualize('Autocomplete', () => {
  story('render', () => {
    snap(
      'default',
      <Autocomplete options={options} placeholder="Something..." />,
    );
    snap(
      'disabled',
      <Autocomplete options={options} disabled placeholder="Something..." />,
    );
    snap(
      'with prefix',
      <Autocomplete
        prefix={<Toolbox />}
        options={options}
        placeholder="Something..."
      />,
    );
    snap(
      'line theme',
      <Autocomplete
        prefix={<Toolbox />}
        options={options}
        theme={DropdownTheme.Line}
        placeholder="Something..."
      />,
    );
  });

  const WstTest = ({
    variables,
  }: {
    variables: Record<`--wst-${string}`, string>;
  }) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          ...variables,
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: '20px',
            flexDirection: 'column',
          }}
        >
          <Autocomplete
            options={options}
            theme={DropdownTheme.Box}
            disabled
            placeholder="disabled placeholder"
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Box}
            disabled
            initialSelectedId={options[0].id}
            placeholder="disabled placeholder"
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Box}
            placeholder="placeholder"
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Box}
            prefix={<Toolbox />}
            suffix={<Toolbox />}
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Box}
            error
            errorMessage="some message"
          />
        </div>

        <div
          style={{
            display: 'flex',
            gap: '20px',
            flexDirection: 'column',
          }}
        >
          <Autocomplete
            options={options}
            theme={DropdownTheme.Line}
            disabled
            placeholder="disabled placeholder"
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Line}
            disabled
            initialSelectedId={options[0].id}
            placeholder="disabled placeholder"
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Line}
            placeholder="placeholder"
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Line}
            prefix={<Toolbox />}
            suffix={<Toolbox />}
          />
          <Autocomplete
            options={options}
            theme={DropdownTheme.Line}
            error
            errorMessage="some message"
          />
        </div>
      </div>
    );
  };

  story('wst variables', () => {
    snap('primary background color', () => (
      <WstTest
        variables={{
          '--wst-primary-background-color-rgb': '0,255,0',
        }}
      />
    ));

    snap('paragraph 2', () => (
      <WstTest
        variables={{
          '--wst-paragraph-2-color-rgb': '0,255,0',
          '--wst-paragraph-2-font-family': 'Libre Baskerville',
          '--wst-paragraph-2-font-size': '22px',
          '--wst-paragraph-2-font-weight': 'bold',
          '--wst-paragraph-2-font-style': 'italic',
          '--wst-paragraph-2-font-variant': 'small-caps',
        }}
      />
    ));

    snap('shade 3', () => (
      <WstTest
        variables={{
          '--wst-shade-3-color-rgb': '0,255,0',
        }}
      />
    ));

    snap('system disabled color', () => (
      <WstTest
        variables={{
          '--wst-system-disabled-color-rgb': '0,255,0',
        }}
      />
    ));

    snap('system error color', () => (
      <WstTest
        variables={{
          '--wst-system-error-color-rgb': '0,255,0',
        }}
      />
    ));
  });

  story('font overrides', () => {
    snap('default', () => (
      <div>
        <WstTest variables={{}} />
      </div>
    ));

    snap('tpa font', () => (
      <div className={classes.tpaFontOverrides}>
        <WstTest variables={{}} />
      </div>
    ));
  });
});
